import { useEffect } from 'react';
import {
  useFacialRegistrationContext,
  FACIAL_STEPS,
} from '../../../../../store/FacialRegistration';
import StepPreparation from './components/StepPreparation';
import StepCapture from './components/StepCapture';
import StepConfirmation from './components/StepConfirmation';
import StepSubmitting from './components/StepSubmitting';

const FacialRegistrationFlow = () => {
  const { step } = useFacialRegistrationContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const steps = {
    [FACIAL_STEPS.PREPARATION]: <StepPreparation />,
    [FACIAL_STEPS.CAPTURE]: <StepCapture />,
    [FACIAL_STEPS.CONFIRMATION]: <StepConfirmation />,
    [FACIAL_STEPS.SUBMITTING]: <StepSubmitting />,
  };

  return steps[step] || steps[FACIAL_STEPS.PREPARATION];
};

export default FacialRegistrationFlow;
